// extracted by mini-css-extract-plugin
export default {"root":"VacationDaysInfoList_root__39usE"};